import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { Globals } from 'app/globals';
import { LoaderService } from 'app/services/loader.service';
import { MetaService } from 'app/services/meta.service';
import { BaseComponent } from '../base/base.component';
import { FragmentService } from '../../services/fragment.service';

@Component({
  selector: 'app-contact-sales',
  templateUrl: './contact-sales.component.html',
  standalone: false,
})
export class ContactSalesComponent extends BaseComponent implements OnInit {
  productName: string;

  constructor(
    public loaderService: LoaderService,
    public globals: Globals,
    public metaService: MetaService,
    public fragmentService: FragmentService,
    private router: Router
  ) {
    super(fragmentService, loaderService, metaService);
  }

  ngOnInit() {
    const currentUrl = this.router.url;
    const productFamilyArray = currentUrl.split('/');
    const productFamilyApiArray = productFamilyArray[productFamilyArray.length - 2].split('-');
    const capitalizeProductFamilyApiArray = productFamilyApiArray.map(
      (api) => api.charAt(0).toUpperCase() + api.substring(1)
    );
    this.productName = capitalizeProductFamilyApiArray.join(' ');
    this.loaderService.loadingContent.emit(false);
  }
}
